import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Creditor} from '../services/creditor';
import {Order} from '../services/order';
import {CreditorsService} from '../services/creditors.service';
import {OrdersService} from '../services/orders.service';
import {faCodeFork, faTrash} from "@fortawesome/free-solid-svg-icons";
import {OrderLine} from "../services/order-line";

@Component({
    selector: 'app-purchase-order-sourcing-modal',
    templateUrl: './purchase-order-sourcing-modal.component.html',
    styleUrls: ['./purchase-order-sourcing-modal.component.scss'],
    providers: [CreditorsService, OrdersService]
})
export class PurchaseOrderSourcingModalComponent implements OnInit {

    protected readonly faTrash = faTrash;
    protected readonly faCodeFork = faCodeFork;

    public order: Order;
    public _order: Order;

    public creditors: Creditor[];

    public saving = false;
    public saved;

    sourcedLines = {};

    constructor(
        public activeModal: NgbActiveModal,
        public creditorsService: CreditorsService,
        public ordersService: OrdersService) {
    }

    ngOnInit(): void {
        this._order = JSON.parse(JSON.stringify(this.order));

        this.creditorsService.getCreditors(1, -1, false, false, null).subscribe(creditors => {
            this.creditors  = creditors.data;
        });
    }

    close(): void {
        this.activeModal.dismiss();
    }

    addSource(orderLine: OrderLine): void {
        if (!this.sourcedLines.hasOwnProperty(orderLine.id)) {
            this.sourcedLines[orderLine.id] = [];
        }

        let creditorId = orderLine.product?.creditor_id ?? null;

        if (creditorId && !this.creditors.some(c => c.id === creditorId)) {
            creditorId = null;
        }

        this.sourcedLines[orderLine.id].push({
            creditor: creditorId,
            quantity: 1
        });
    }

    removeSource(orderLine: OrderLine, source: any): void {
        let index = this.sourcedLines[orderLine.id].indexOf(source);
        this.sourcedLines[orderLine.id].splice(index, 1);

        if (this.sourcedLines[orderLine.id].length === 0) {
            delete this.sourcedLines[orderLine.id];
        }
    }

    save(): void {
        let data = this.formatSourcedLines();

        this.saving = true;

        this.ordersService.sourceOrder(this.order, data).subscribe(() => {
            this.activeModal.dismiss();
            this.saved(data);
        }, () => {
            this.saving = false;
        });
    }

    formatSourcedLines(): { creditor_id: string, order_lines: { id: string, quantity: number }[] }[] {
        const formatted: { [creditorId: string]: { id: string, quantity: number }[] } = {};

        for (const orderLineId in this.sourcedLines) {
            for (const source of this.sourcedLines[orderLineId]) {
                const quantity = Number(source.quantity);

                if (!source.creditor || !quantity || quantity < 1) {
                    continue;
                }

                const creditorId = source.creditor;

                if (!formatted.hasOwnProperty(creditorId)) {
                    formatted[creditorId] = [];
                }

                formatted[creditorId].push({
                    id: orderLineId,
                    quantity
                });
            }
        }

        return Object.keys(formatted).map((creditorId) => {
            return {
                creditor_id: creditorId,
                order_lines: formatted[creditorId]
            };
        });
    }

    isSourceNotEmptyAndValid(): boolean {
        if (Object.keys(this.sourcedLines).length === 0) {
            return false;
        }

        for (let orderLineId in this.sourcedLines) {
            if (this.sourcedLines[orderLineId].length === 0) {
                return false;
            }

            for (let i = 0; i < this.sourcedLines[orderLineId].length; i++) {
                if (this.sourcedLines[orderLineId][i].creditor === null || this.sourcedLines[orderLineId][i].quantity === null || this.sourcedLines[orderLineId][i].quantity < 1) {
                    return false;
                }
            }
        }

        return true;
    }
}
